import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { FaAward } from "react-icons/fa6";
import Recognitions from "./index"

const recognitionWallRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Recognition Wall",
        basePath: "recognitions-wall",
        mainComponent: <Recognitions />,
        layout: "/console",	   
        icon: <FaAward className="icon-item" />,
        subTitle:"Recognition Wall",
        level:5,
        moduleId: 0,
    })
]

export default recognitionWallRoutes;